const DocumentsCard = ({ item }) => {
  const {
    iconImg,
    title,

    expiredCount,
    oneToSevenCount,
    eightToThirtyCount,
    thirtyOneToSixtyCount,

    handleExpired,
    handleOneToSeven,
    handleEightToThirty,
    handleThirtyOneToSixty,
  } = item;

  const cardStyles = {
    "Employement Visa": {
      cardBg: "bg-[#F4F3FF]",
      iconBg: "bg-[#E1DEFF]",
    },

    "Employee Passport": {
      cardBg: "bg-[#FFF3F3]",
      iconBg: "bg-[#FFD8D8]",
    },

    "Emirates ID": {
      cardBg: "bg-[#E0F9FF]",
      iconBg: "bg-[#99EBFF]",
    },

    "Medical Insurance Card": {
      cardBg: "bg-[#FEF4DC]",
      iconBg: "bg-[#FFE5A5]",
    },

    "Labour Card": {
      cardBg: "bg-[#F3ECFF]",
      iconBg: "bg-[#D9C2FF]",
    },

    "DMCC Access Card": {
      cardBg: "bg-[#D2FBE2]",
      iconBg: "bg-[#8DFEB9]",
    },
  };

  const style = cardStyles[title] || {
    cardBg: "bg-white",
    iconBg: "bg-gray-100",
  };

  return (
    <div
      className={`flex items-center justify-between p-4 rounded-lg ${style.cardBg}`}
    >
      {/* Left Section */}
      <div className="flex items-center gap-3">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center ${style.iconBg}`}
        >
          <img src={iconImg} alt={title} />
        </div>

        <div>
          <h5 className="text-sm font-medium text-[#505050]">
            {title}
          </h5>

          <p className="text-[10px] text-[#909090]">
            Expiry Details
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div className="grid grid-cols-2 gap-2">
        <div
          onClick={handleExpired}
          className="cursor-pointer bg-white rounded-full px-3 py-0.5 flex items-center gap-2"
        >
          <div className="w-2 h-2 rounded-full bg-red-500" />
          <span className="text-[10px] text-gray-500">
            Expired:
          </span>
          <p className="text-xs font-semibold">
            {expiredCount}
          </p>
        </div>

        <div
          onClick={handleOneToSeven}
          className="cursor-pointer bg-white rounded-full px-3 py-0.5 flex items-center gap-2"
        >
          <div className="w-2 h-2 rounded-full bg-orange-500" />
          <span className="text-[10px] text-gray-500">
            1-7 Days:
          </span>
          <p className="text-xs font-semibold">
            {oneToSevenCount}
          </p>
        </div>

        <div
          onClick={handleEightToThirty}
          className="cursor-pointer bg-white rounded-full px-3 py-0.5 flex items-center gap-2"
        >
          <div className="w-2 h-2 rounded-full bg-yellow-500" />
          <span className="text-[10px] text-gray-500">
            8-30 Days:
          </span>
          <p className="text-xs font-semibold">
            {eightToThirtyCount}
          </p>
        </div>

        <div
          onClick={handleThirtyOneToSixty}
          className="cursor-pointer bg-white rounded-full px-3 py-0.5 flex items-center gap-2"
        >
          <div className="w-2 h-2 rounded-full bg-green-500" />
          <span className="text-[10px] text-gray-500">
            31-60 Days:
          </span>
          <p className="text-xs font-semibold">
            {thirtyOneToSixtyCount}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DocumentsCard;